import React, { useState, useEffect } from 'react';
import { 
  Grid, 
  TextField, 
  MenuItem, 
  FormControl, 
  InputLabel, 
  Select,
  Button,
  Box,
  Typography
} from '@mui/material';
import axios from 'axios';
import config from '../utils/config';

const DashboardFilters = ({ onFilterChange }) => {
  const [branches, setBranches] = useState([]);
  const [filters, setFilters] = useState({
    branchId: '',
    startDate: '',
    endDate: '',
    periodType: 'monthly'
  });
  
  // Cargar sucursales al montar el componente
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const response = await axios.get(`${config.API_URL}/branches/`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setBranches(response.data);
      } catch (error) {
        console.error('Error al cargar sucursales:', error);
      }
    };
    
    fetchBranches();
  }, []);
  
  // Manejar cambios en los filtros
  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };
  
  // Aplicar filtros
  const applyFilters = () => {
    onFilterChange(filters);
  };
  
  // Restablecer filtros
  const resetFilters = () => {
    const defaultFilters = {
      branchId: '',
      startDate: '',
      endDate: '',
      periodType: 'monthly'
    };
    setFilters(defaultFilters);
    onFilterChange(defaultFilters);
  };
  
  return (
    <Box sx={{ mb: 3, p: 2, borderRadius: 1, bgcolor: 'background.paper', boxShadow: 1 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Filtros del Dashboard</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel id="branch-select-label">Sucursal</InputLabel>
            <Select
              labelId="branch-select-label"
              id="branch-select"
              name="branchId"
              value={filters.branchId}
              label="Sucursal"
              onChange={handleFilterChange}
            >
              <MenuItem value="">Todas las sucursales</MenuItem>
              {branches.map((branch) => (
                <MenuItem key={branch.id} value={branch.id}>
                  {branch.branch_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            id="start-date"
            label="Fecha Inicio"
            type="date"
            name="startDate"
            value={filters.startDate}
            onChange={handleFilterChange}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            id="end-date"
            label="Fecha Fin"
            type="date"
            name="endDate"
            value={filters.endDate}
            onChange={handleFilterChange}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={2}>
          <FormControl fullWidth>
            <InputLabel id="period-type-label">Tipo de Período</InputLabel>
            <Select
              labelId="period-type-label"
              id="period-type"
              name="periodType"
              value={filters.periodType}
              label="Tipo de Período"
              onChange={handleFilterChange}
            >
              <MenuItem value="monthly">Mensual</MenuItem>
              <MenuItem value="quarterly">Trimestral</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={applyFilters}
            sx={{ mr: 1 }}
          >
            Aplicar
          </Button>
          <Button 
            variant="outlined" 
            onClick={resetFilters}
          >
            Limpiar
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardFilters;
